import { createContext, useContext, useState } from "react";

const SidebarLayoutContext = createContext(null);

export const SidebarLayoutProvider = ({ children, hasSidebar = true }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  return (
    <SidebarLayoutContext.Provider
      value={{ isSidebarOpen, toggleSidebar, hasSidebar }}
    >
      {children}
    </SidebarLayoutContext.Provider>
  );
};

export const useSidebarLayout = () => {
  const ctx = useContext(SidebarLayoutContext);
  if (!ctx)
    throw new Error("useSidebarLayout must be used within SidebarLayoutProvider");
  return ctx;
};
